// Exposes the state below window.$boliaStores$.[your state] when in develop mode.
export default function makeStoreDebugAccessible(key: string, state: any) {
    if (process.env.NODE_ENV !== 'production') {
        const mainKey = '$stores$';
        window[mainKey] = window[mainKey] || {};
        window[mainKey][key] = state;
    }
}
